import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import api from "api";
import logo from "../../../assets/images/trade_text_transparent.png";
import "../../Auth/login.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      try {
        const decoded = jwt_decode(token);
        if (!decoded.exp || decoded.exp > Date.now() / 1000) {
          history.replace("/admin");
        } else {
          localStorage.removeItem("adminToken");
        }
      } catch {
        localStorage.removeItem("adminToken");
      }
    }
  }, [history]);

  const handleLogin = async () => {
    if (!email || !password) {
      toast.error("Please enter email and password.", {
        position: "top-center",
        containerId: "main",
        theme: "light",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await api.post("/auth/admin-login", { email, password });
      if (res.data.success) {
        localStorage.setItem("adminToken", res.data.data.token);
        toast.success("Welcome, Admin!", {
          position: "top-center",
          containerId: "main",
          theme: "light",
        });
        history.push("/admin");
      }
    } catch (err) {
      const status = err?.response?.status;
      const msg =
        err?.response?.data?.message ||
        (status === 400 ? "Email not registered." :
         status === 401 ? "Incorrect password." :
         status === 403 ? "You don't have admin access." :
         "Login failed. Please try again.");
      toast.error(msg, {
        position: "top-center",
        containerId: "main",
        theme: "light",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f5f5f5" }}>
      <div style={{ display: "flex", padding: "25px 20px", background: "#fff", borderBottom: "1px solid #e9e9e9" }}>
        <img src={logo} alt="TradeTribeFwd" style={{ height: 65 }} />
      </div>
    <div className="login-form-container">
      <form className="login-form" style={{ height: "auto", paddingTop: 0, paddingBottom: 0 }} onSubmit={(e) => e.preventDefault()}>
        <div className="login-form-content" style={{ paddingTop: 48, paddingBottom: 48 }}>
          <p className="login-text-login">Admin Login</p>
          <p className="login-text py-[20px]">Enter your admin credentials</p>
          <div className="form-group mt-4">
            <input
              type="email"
              className="form-control !py-2.5 rounded-xl"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group mt-4">
            <input
              type="password"
              className="form-control !py-2.5 rounded-xl"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleLogin()}
            />
          </div>
          <div className="form-group mt-6 btn-center">
            <button
              type="button"
              className="btn btn-success btn-login text-white"
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </div>
        </div>
      </form>
    </div>
    </div>
  );
};

export default AdminLogin;
